/**
 * WorkSite form.
 *
 * JOB_BILLING_REFACTOR PR-C (2026-05) — billing (pricing, recurrence,
 * forfait) moved to the Mission (Job). The WorkSite form is now a plain
 * location / compliance / contract form with no interactive billing
 * card, months grid, or price-change confirmation. Its <select> inputs
 * live inside ``#main-content`` and are upgraded by the global
 * ``app.js`` ``initCustomSelects`` pass, so this module no longer needs
 * to do anything.
 *
 * The exports are kept so the auto-init registry
 * (``[data-auto-init="worksiteForm"]``) resolves cleanly ; they are
 * intentional no-ops.
 */

export function initWorksiteForm() {
    // No-op — see module docstring.
}

export function autoInitWorksiteForm() {
    initWorksiteForm();
}
